export function hasDuplicateMarketRegisterNumbers(order) {
  const plant = order?.maStR;
  const storage = order?.storage_maStR;

  return Boolean(
    (plant?.EEG_number && plant.EEG_number === storage?.EEG_number) ||
      (plant?.storage_number &&
        plant.storage_number === storage?.storage_number)
  );
}
